import { ApiQueryName } from "@/models/api"
import { httpClient, toHttpError } from "@/utils/api"
import type { SuccessData } from "@/utils/api"
import { useQuery } from "@tanstack/react-query"

import { createQueryKey } from "../utils/createQueryKey"
import { useRenameQueryResult } from "../utils/useRenameQueryResult"

const validateAccount = async (token: string) => {
  try {
    const response = await httpClient.get<SuccessData>("/users/confirmation", {
      params: { confirmation_token: token },
    })

    return response
  } catch (error: unknown) {
    throw toHttpError(error)
  }
}

/**
 * Validates an account with the given token
 *
 * @param token The token with which to validate the account
 */
export const useValidateAccount = (token: string) => {
  const queryKey = createQueryKey(ApiQueryName.ValidateAccount, "getOne", token)

  const queryResult = useQuery({
    gcTime: Infinity,
    queryFn: async () => validateAccount(token),
    queryKey,
    staleTime: Infinity,
  })

  return useRenameQueryResult(queryResult, ApiQueryName.ValidateAccount)
}
